export const getStorageKeysForNetwork = () => {
  const asignaRefresh = 'refreshToken';
  const asignaWalletId = 'asignaWalletId';
  const walletType = 'walletType';
  const derivationPath = 'derivationPath';
  const ownerPk = 'ownerPk';
  const testnetAddress = 'testnetAddress';
  const mainnetAddress = 'mainnetAddress';
  const safeSettings = 'safeSettings';

  return {
    asignaRefresh,
    asignaWalletId,
    walletType,
    derivationPath,
    ownerPk,
    testnetAddress,
    mainnetAddress,
    safeSettings,
  };
};
